import React, { createContext, useContext, useState, useEffect } from "react";

const LocaleContext = createContext(null);

const dict = {
  nav: {
    regions: { en: "Destinations", ro: "Destinații" },
    tools:   { en: "Tools",   ro: "Tools" },
    plan: { en: "Plan", ro: "Planifică" },
    concierge: { en: "Concierge", ro: "Ghidul" },
    about:   { en: "About",   ro: "Despre" },
    contact: { en: "Contact", ro: "Contact" },
  },
  legal: {
    privacy: { en: "Privacy", ro: "Confidențialitate" },
    terms:   { en: "Terms",   ro: "Termeni" },
    cookies: { en: "Cookies", ro: "Cookie-uri" },
    heading: { en: "Trust",   ro: "Încredere" },
  },
  hero: {
    kicker: { en: "Romania, in extraordinary detail.", ro: "România, în detaliu extraordinar." },
    title: {
      en: ["Painted monasteries.", "Wild Carpathians.", "Belle Époque boulevards."],
      ro: ["Mănăstiri pictate.", "Carpați sălbatici.", "Bulevarde Belle Époque."]
    },
    sub: {
      en: "The reference travel platform for Romania — utility tools that actually work, a Concierge that actually knows, and nine worlds worth writing home about.",
      ro: "Platforma de referință pentru călătoriile în România — tools care chiar funcționează, un Concierge care chiar știe și nouă lumi despre care merită scris acasă."
    },
    cta_primary: { en: "Ask the Concierge", ro: "Întreabă Ghidul" },
    cta_secondary: { en: "Explore Tools", ro: "Vezi Tools" },
  },
  regions: {
    heading: { en: "Explore Romania", ro: "Explorează România" },
    sub: {
      en: "Choose one of Romania's great cultural landscapes and begin your journey.",
      ro: "Alege una dintre marile zone culturale ale României și începe călătoria."
    },
    highlights: { en: "Highlights", ro: "Puncte-cheie" },
    open: { en: "Explore this world", ro: "Explorează această lume" },
  },
  tools: {
    heading: { en: "Utility, done right.", ro: "Utilitare, făcute cum trebuie." },
    sub: {
      en: "Five tools. Real data. No dark patterns.",
      ro: "5 TOOLS. Date reale. Fără tertipuri."
    },
    currency: { en: "Currency", ro: "Valută" },
    currency_sub: { en: "Live RON exchange rates. Convert any pair.", ro: "Cursuri RON live. Conversie orice pereche." },
    distance: { en: "Distance", ro: "Distanțe" },
    distance_sub: { en: "Between any two Romanian cities. Fuel + time estimated.", ro: "Între orice două orașe. Combustibil + timp estimat." },
    budget:   { en: "Budget", ro: "Buget" },
    budget_sub: { en: "Realistic trip cost, calibrated to Romania 2026.", ro: "Cost realist, calibrat România 2026." },
    weather:  { en: "Weather", ro: "Vreme" },
    weather_sub: { en: "5-day forecast for major cities, from Open-Meteo.", ro: "Prognoză 5 zile, principalele orașe, Open-Meteo." },
    phrasebook: { en: "Phrasebook", ro: "Frazele esențiale" },
    phrasebook_sub: { en: "40+ essential Romanian phrases with pronunciation.", ro: "Peste 40 de fraze esențiale cu pronunție." },
    open: { en: "Open tool", ro: "Deschide tool" },
  },
  concierge: {
    heading: { en: "A travel adviser who knows Romania.", ro: "Un sfătuitor de călătorie care cunoaște România." },
    sub: {
      en: "Ask anything about traveling in Romania — history, routes, food, timing, logistics.",
      ro: "Întreabă orice despre călătoriile în România — istorie, rute, mâncare, programare, logistică."
    },
    open: { en: "Open full chat", ro: "Deschide chatul complet" },
    placeholder: { en: "Ask about Romania…", ro: "Întreabă despre România…" },
    send: { en: "Send", ro: "Trimite" },
    thinking: { en: "Thinking…", ro: "Se gândește…" },
    starters_en: [
      "Best 5-day Transylvania road trip in April",
      "Where to see bears safely near Brașov",
      "How much cash should I bring for a week?",
      "Weekend in Bucharest — food and neighborhoods",
    ],
    starters_ro: [
      "Cel mai bun road trip de 5 zile în Transilvania în aprilie",
      "Unde pot vedea urși în siguranță lângă Brașov",
      "Câți bani cash să iau pentru o săptămână?",
      "Weekend în București — mâncare și cartiere",
    ],
  },
  newsletter: {
    kicker: { en: "Newsletter", ro: "Newsletter" },
    heading: {
      en: "One email a week.\nOnly what deserves to be read.",
      ro: "Un email pe săptămână.\nDoar ce merită citit."
    },
    status: { en: "Coming Soon", ro: "În curând" },
    body: {
      en: "We're preparing something worth reading. Newsletter subscriptions will open after the official launch.",
      ro: "Pregătim ceva care chiar merită citit. Înscrierile la newsletter vor fi disponibile după lansarea oficială."
    },
  },
  footer: {
    tagline: { en: "The reference travel platform for Romania.", ro: "Platforma de referință pentru călătoriile în România." },
    made: { en: "Built with reverence in", ro: "Construit cu respect în" },
    rights: { en: "All rights reserved.", ro: "Toate drepturile rezervate." },
    copyright_line: {
      en: "WowRomania.com. All rights reserved. — Built with reverence in București",
      ro: "WowRomania.com. Toate drepturile rezervate • Construit cu respect pentru România.",
    },
  },
  common: {
    from: { en: "From", ro: "De la" },
    to:   { en: "To",   ro: "La" },
    amount: { en: "Amount", ro: "Sumă" },
    calculate: { en: "Calculate", ro: "Calculează" },
    result: { en: "Result", ro: "Rezultat" },
    days: { en: "Days", ro: "Zile" },
    travelers: { en: "Travelers", ro: "Călători" },
    style: { en: "Style", ro: "Stil" },
    regions_visited: { en: "Regions visited", ro: "Regiuni vizitate" },
    budget_tier: { en: "budget", ro: "econom" },
    mid_tier: { en: "mid", ro: "mediu" },
    premium_tier: { en: "premium", ro: "premium" },
    city: { en: "City", ro: "Oraș" },
    total: { en: "Total", ro: "Total" },
    per_person: { en: "Per person", ro: "Pe persoană" },
    per_day: { en: "Per day", ro: "Pe zi" },
    live: { en: "LIVE", ro: "LIVE" },
    fallback: { en: "OFFLINE RATE", ro: "CURS OFFLINE" },
    loading: { en: "Loading…", ro: "Se încarcă…" },
    error: { en: "Something went wrong", ro: "Ceva n-a mers" },
  },
};

// Locale registry. To add a new language, register it here (and add strings to the dict above).
export const SUPPORTED_LOCALES = ["en", "ro"];
export const DEFAULT_LOCALE = "en";
const STORAGE_KEY = "wr_locale";

/**
 * Resolve the initial locale with priority:
 *   1. Explicit user preference from localStorage (if it's a supported locale)
 *   2. Browser preferences from navigator.languages / navigator.language — first match wins
 *   3. DEFAULT_LOCALE
 * Runs synchronously in the useState initializer → no flicker between languages.
 */
function resolveInitialLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch (_) { /* localStorage may be unavailable */ }

  const nav = window.navigator || {};
  const candidates = [];
  if (Array.isArray(nav.languages)) candidates.push(...nav.languages);
  if (nav.language) candidates.push(nav.language);

  for (const raw of candidates) {
    if (!raw) continue;
    const primary = String(raw).toLowerCase().split(/[-_]/)[0];
    if (SUPPORTED_LOCALES.includes(primary)) return primary;
  }
  return DEFAULT_LOCALE;
}

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(resolveInitialLocale);

  // Set <html lang> synchronously on mount so screen readers and SEO see the right lang immediately.
  if (typeof document !== "undefined" && document.documentElement.lang !== locale) {
    document.documentElement.lang = locale;
  }

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, locale); } catch (_) { /* ignore */ }
    document.documentElement.lang = locale;
  }, [locale]);

  const setLocale = (l) => {
    if (!SUPPORTED_LOCALES.includes(l)) return;
    setLocaleState(l);
  };

  const t = (path) => {
    const parts = path.split(".");
    let cur = dict;
    for (const p of parts) { cur = cur?.[p]; if (cur === undefined) return path; }
    if (cur && typeof cur === "object" && (cur.en !== undefined || cur.ro !== undefined)) {
      return cur[locale] ?? cur[DEFAULT_LOCALE];
    }
    return cur;
  };
  return <LocaleContext.Provider value={{ locale, setLocale, t, supportedLocales: SUPPORTED_LOCALES }}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale outside provider");
  return ctx;
}
